module.exports = __webpack_public_path__ + "assets/img/Groups1048.2121f07a.png";